export const getFormCategories = (flatFormFields) =>
  flatFormFields
    .filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          ({ category }) => category.label.id === value.category.label.id
        )
    )
    .map(({ category }) => category.label);
